import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const ReportsIcon = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 17 20"
    style={{ fill: 'none', width: '25px', height: '25px', strokeWidth: '.06rem' }}
  >
    <path d="M15.1667 18.3991H1V1H10.1667L15.1667 5.53889V18.3991Z" />
    <path d="M10.1665 1V5.53889H15.1665" />
    <path d="M8.5 8.56494H11.8333" />
    <path d="M8.5 11.5908H11.8333" />
    <path d="M8.5 14.6167H11.8333" />
    <path d="M6.83333 7.05176L4.75 8.94295L3.5 7.80823" />
    <path d="M6.83333 10.0776L4.75 11.9688L3.5 10.8341" />
    <path d="M6.83333 13.1035L4.75 14.9947L3.5 13.86" />
  </SvgIcon>
);

export default ReportsIcon;
